import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { checkUserPermissions } from '@/components/Auth/checkUserPermissions';

export const useSearchShortcut = (tenantId: string) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        !(event.ctrlKey || event.metaKey) ||
        event.key.toLowerCase() !== 'f'
      ) {
        return;
      }

      if (!checkUserPermissions({ permission: 'tenant:viewer' })) {
        return;
      }

      event.preventDefault();
      navigate({ to: '/$tenantId/search', params: { tenantId } });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, tenantId]);
};
